import { styledPolymorphic } from '@qred/components-library';

export const TimelineContainer = styledPolymorphic()((_styled) =>
  _styled(() => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
  }))
);

export const StepContainer = styledPolymorphic()((_styled) =>
  _styled(() => ({
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: '4px',
    flex: 1,
    minWidth: 0,
  }))
);

export const StepIndicatorContainer = styledPolymorphic()((_styled) =>
  _styled(() => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  }))
);

export const ConnectorLine = styledPolymorphic<
  'div',
  {
    $isCompleted: boolean;
    $position: 'left' | 'right';
    $invisible?: boolean;
  }
>()((_styled) =>
  _styled(({ $invisible, $isCompleted, $position, theme }) => ({
    flex: 1,
    height: '4px',
    visibility: $invisible ? 'hidden' : 'visible',
    backgroundColor: $isCompleted
      ? theme.fn.themeColor('Border/Active')
      : theme.fn.themeColor('Border/Disabled'),
    marginRight: $position === 'left' ? '-4px' : '0',
  }))
);

export const CheckpointIcon = styledPolymorphic<
  'div',
  { $isActive: boolean }
>()((_styled) =>
  _styled(() => ({
    width: '24px',
    height: '24px',
    marginRight: '-4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative' as const,
  }))
);

export const StepLabel = styledPolymorphic<'div', { $isCompleted: boolean }>()(
  (_styled) =>
    _styled(() => ({
      textAlign: 'center' as const,
      width: '100%',
      wordWrap: 'break-word' as const,
      hyphens: 'auto' as const,
    }))
);
